/**
 * Copies an array.
 * @param {Array} array - Array to be copied.
 * @return {Array} Copied array.
 */
export default function immutableCopy(array) {
  return [...array];
}
